export default __webpack_public_path__ + "static/media/truck-he.1f14041d.png";